import { render } from "./FlouView.vue?vue&type=template&id=27ac3f23&scoped=true"
import script from "./FlouView.vue?vue&type=script&lang=js"
export * from "./FlouView.vue?vue&type=script&lang=js"

import "./FlouView.vue?vue&type=style&index=0&id=27ac3f23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ac3f23"]])

export default __exports__